import React, { useEffect, useMemo } from "react"
import { Container } from "reactstrap"
import { getUsers } from "../../api"
import TableContainer from "../../components/Common/TableContainer"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"

function UsersPage({ t }) {
  const [users, setUsers] = React.useState([])
  useEffect(() => {
    getUsers().then(res => {
      console.log(res)
      setUsers(res)
    })
  }, [])
  document.title = t("Users")
  const columns = useMemo(
    () => [
      {
        header: t("ID"),
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: t("Verified"),
        accessorKey: "verified",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ cell }) => {
          const verified = cell.getValue()
          const backgroundColor = verified ? "green" : "red"
          return (
            <span
              style={{
                backgroundColor,
                color: "white",
                padding: "2px 5px",
                borderRadius: "3px",
              }}
            >
              {verified ? t("Yes") : t("No")}
            </span>
          )
        },
      },
      {
        header: t("AML status"),
        accessorKey: "amlRiskStatus",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ cell }) => {
          const amlRiskStatus = cell.getValue()
          const backgroundColor =
            amlRiskStatus === "low"
              ? "green"
              : amlRiskStatus === "medium"
              ? "orange"
              : amlRiskStatus === "high"
              ? "red"
              : "gray"

          return (
            <span
              style={{
                backgroundColor,
                color: "white",
                padding: "2px 5px",
                borderRadius: "3px",
              }}
            >
              {amlRiskStatus
                ? t(amlRiskStatus.charAt(0).toUpperCase() + amlRiskStatus.slice(1))
                : t("unknown")}
            </span>
          )
        },
      },
      {
        header: t("Name"),
        accessorKey: "fullName",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: t("Phone"),
        accessorKey: "phoneNumber",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: t("Email"),
        accessorKey: "email",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: t("DocumentID"),
        accessorKey: "documentId",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: t("Address"),
        accessorKey: "address",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: t("Chat ID"),
        accessorKey: "chatId",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: t("Blocked"),
        accessorKey: "blocked",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ cell }) => {
          const blocked = cell.getValue()
          const backgroundColor = blocked ? "red" : "green"
          return (
            <span
              style={{
                backgroundColor,
                color: "white",
                padding: "2px 5px",
                borderRadius: "3px",
              }}
            >
              {blocked ? t("Yes") : t("No")}
            </span>
          )
        },
      },
      {
        header: t("Language"),
        accessorKey: "language",
        enableColumnFilter: false,
        enableSorting: true,
      },
    ],
    [t]
  )
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <h2>{t("Users")}</h2>
          <TableContainer
            columns={columns}
            data={users || []}
            isGlobalFilter={true}
            isCustomPageSize={true}
            isPagination={true}
            SearchPlaceholder={users.length + " " + t("records") + "..."}
            pagination="pagination"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />{" "}
        </Container>
      </div>
    </React.Fragment>
  )
}

UsersPage.propTypes = {
  t: PropTypes.func.isRequired,
}

export default withTranslation()(UsersPage)
